import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface DynamicSectionProps {
  id?: string;
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  containerClassName?: string;
}

const DynamicSection: React.FC<DynamicSectionProps> = ({
  id,
  title,
  subtitle,
  children,
  className = '',
  titleClassName = '',
  containerClassName = '',
}) => {
  return (
    <section id={id} className={`py-16 md:py-24 ${className}`}>
      <div className={`container mx-auto px-4 ${containerClassName}`}>
        {(title || subtitle) && (
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            {title && (
              <h2 className={`text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 ${titleClassName}`}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">{subtitle}</p>
            )}
          </motion.div>
        )}
        {children}
      </div>
    </section>
  );
};

export default DynamicSection;
